import { render, staticRenderFns } from "./IconArrowMenu.vue?vue&type=template&id=502fe878&scoped=true"
import script from "./IconArrowMenu.vue?vue&type=script&lang=js"
export * from "./IconArrowMenu.vue?vue&type=script&lang=js"
import style0 from "./IconArrowMenu.vue?vue&type=style&index=0&id=502fe878&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502fe878",
  null
  
)

export default component.exports